function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.007,
    height: 35.978,
    viewBox: "0 0 36.007 35.978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.62 8.17a15.991 15.991 0 1 1-25.24 0L3.95 6.74a18 18 0 1 0 28.11-.01l-1.43 1.43z",
    style: {
      fill: "#f5f5f5"
    },
    transform: "translate(.002 -.006)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.23 6.63 1.41-1.41a18.013 18.013 0 0 0-25.4.05l1.41 1.41a16.043 16.043 0 0 1 22.59-.05",
    style: {
      fill: "#c5d75d"
    },
    transform: "translate(.002 -.006)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.08 8.1 1.06 1.06a12.515 12.515 0 0 1 17.62-.06l1.06-1.06a14 14 0 0 0-19.74.06",
    style: {
      fill: "#c5d75d"
    },
    transform: "translate(.002 -.006)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.91 10.93.71.71a9.012 9.012 0 0 1 12.67-.06l.71-.71a9.989 9.989 0 0 0-14.08.06M21.98 21.01a4 4 0 1 1-8 0c0-2.21 4-7.95 4-7.95s4 5.72 4 7.95m-2.22-1.32a1.04 1.04 0 1 0 1.03 1.05 1.039 1.039 0 0 0-1.03-1.05",
    style: {
      fill: "#c5d75d"
    },
    transform: "translate(.002 -.006)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorTool);
export default __webpack_public_path__ + "static/media/sensor-tool.92f360528e5680b1cef48143465253e7.svg";
export { ForwardRef as ReactComponent };